import React from 'react';
import { createPortal } from 'react-dom';
import { Trans, useTranslation } from 'react-i18next';
import { ContextBreakNode } from '@myriadgenetics/mgh-types';
import getNextNodeId from '../../../helpers/flow/route-flow';
import { H2, Text1 } from '../../../elements/typography';
import NodeFooter from '../../../elements/node-footer';
import Button from '../../../elements/button';
import Card from '../../rac/card';

import './index.scss';
import { useButtonsWrapperContext } from '../../buttons-wrapper';
import { BackButton } from '../../buttons/back';

interface Props {
  node: any | ContextBreakNode;
  responses: any;
  gotoNextNode: (nodeId?: number | null) => void;
}

function ContextBreakNodeReact({ node, responses, gotoNextNode }: Props) {
  const { t } = useTranslation();
  const { buttonsRef } = useButtonsWrapperContext();
  const { messageKey, subMessageKey, footerKey, termsAndPrivacyLinks } = node.data;

  return (
    <div className="context-break-node">
      <H2 className="context-break-node__message heading-small--medium">{t(messageKey)}</H2>
      {subMessageKey && (
        <Text1 className="context-break-node__sub-message">
          <Trans i18nKey={subMessageKey} />
        </Text1>
      )}
      {buttonsRef?.current ? (
        createPortal(
          <>
            <BackButton />
            <Button
              className="context-break-node__continue-button"
              dataTestId="continue-button"
              onClick={() => gotoNextNode(getNextNodeId(node.flows, responses))}
            >
              {t('continue')}
            </Button>
            <BackButton />
          </>,
          buttonsRef.current,
        )
      ) : (
        <div className="context-break-node__continue">
          <Button
            className="context-break-node__continue-button"
            dataTestId="continue-button"
            onClick={() => gotoNextNode(getNextNodeId(node.flows, responses))}
          >
            {t('continue')}
          </Button>
        </div>
      )}
      {footerKey && <NodeFooter footerKey={footerKey} termsAndPrivacyLinks={termsAndPrivacyLinks} />}
    </div>
  );
}

function Wrapper(props: Props) {
  return (
    <Card className="context-break-node__card">
      <ContextBreakNodeReact {...props} />
    </Card>
  );
}

export default Wrapper;
